import React, { useState } from "react";
import {
  createUserWithEmailAndPassword,
  updateProfile,
  getAuth
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { db } from "./firebase";
import { initializeApp, getApps, getApp } from "firebase/app";
import TutorLayout from "./TutorLayout";

// ✅ Firebase safe init for secondary app
const firebaseConfig = {
  apiKey: "AIzaSyCZ189GUfiYhLPJfAZTwdfrdJupI-CrJOw",
  authDomain: "ryan-tutors.firebaseapp.com",
  projectId: "ryan-tutors",
  storageBucket: "ryan-tutors.firebasestorage.app",
  messagingSenderId: "1011578644133",
  appId: "1:1011578644133:web:405c1d3796bb3cdbdc0f4c",
};

const secondaryApp =
  getApps().find(app => app.name === "Secondary") ||
  initializeApp(firebaseConfig, "Secondary");

const secondaryAuth = getAuth(secondaryApp);

function CreateUser() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [surname, setSurname] = useState("");
  const [role, setRole] = useState("student");
  const [subject, setSubject] = useState("");
  const [targetGrade, setTargetGrade] = useState("");
  const [message, setMessage] = useState("");

  const handleCreateUser = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setMessage("❌ Passwords do not match.");
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(
        secondaryAuth,
        email,
        password
      );
      const newUser = userCredential.user;

      await updateProfile(newUser, {
        displayName: displayName,
      });

      await setDoc(doc(db, "users", newUser.uid), {
        email,
        displayName,
        surname,
        role,
        subject,
        targetGrade: role === "student" ? targetGrade : null,
        uid: newUser.uid,
        mustChangePassword: true,
      });

      setMessage(`✅ Successfully created ${role} "${displayName} ${surname}"`);

      // Clear form
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      setDisplayName("");
      setSurname("");
      setRole("student");
      setSubject("");
      setTargetGrade("");
    } catch (error) {
      setMessage(`❌ Error: ${error.message}`);
    }
  };

  const isGCSE = subject.toLowerCase().includes("gcse");
  const isAlevel = subject.toLowerCase().includes("a-level");

  return (
    <TutorLayout>
      <div style={styles.page}>
        <div style={styles.card}>
          <h2 style={styles.heading}>📝 Register a New Student or Tutor</h2>
          <p style={styles.subtext}>Let’s build the classroom one login at a time!</p>

          <form onSubmit={handleCreateUser} style={styles.form} autoComplete="off">
            <input type="text" name="avoid-autofill" style={{ display: "none" }} />

            <input
              type="text"
              placeholder="👤 First Name"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              required
              style={styles.input}
              name="first-name"
              autoComplete="off"
            />
            <input
              type="text"
              placeholder="👤 Last Name"
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              required
              style={styles.input}
              name="last-name"
              autoComplete="off"
            />
            <input
              type="email"
              placeholder="📧 Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
              name="new-email"
              autoComplete="off"
            />
            <input
              type="password"
              placeholder="🔐 Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={styles.input}
              name="new-password"
              autoComplete="new-password"
            />
            <input
              type="password"
              placeholder="🔐 Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={styles.input}
              name="confirm-password"
              autoComplete="new-password"
            />

            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              style={styles.input}
            >
              <option value="student">🎓 Student</option>
              <option value="tutor">📘 Tutor</option>
            </select>

            {role === "student" && (
              <>
                <select
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  style={styles.input}
                >
                  <option value="">📚 Select Subject</option>
                  <option value="GCSE Maths">GCSE Maths</option>
                  <option value="A-Level Maths">A-Level Maths</option>
                  <option value="GCSE French">GCSE French</option>
                  <option value="A-Level French">A-Level French</option>
                </select>

                <label style={{ textAlign: "left", fontWeight: "500" }}>
                  🎯 Target Grade or Level:
                </label>
                <select
                  value={targetGrade}
                  onChange={(e) => setTargetGrade(e.target.value)}
                  style={styles.input}
                >
                  <option value="">-- Select --</option>
                  {isGCSE &&
                    [...Array(9)].map((_, i) => (
                      <option key={i + 1} value={`Grade ${i + 1}`}>
                        Grade {i + 1}
                      </option>
                    ))}
                  {isAlevel && (
                    <>
                      <option value="AS">AS Level</option>
                      <option value="A-Level">A-Level</option>
                    </>
                  )}
                </select>
              </>
            )}

            <button type="submit" style={styles.button}>
              🎉 Create User
            </button>
          </form>

          {message && <p style={styles.message}>{message}</p>}
        </div>
      </div>
    </TutorLayout>
  );
}

const styles = {
  page: {
    background: "linear-gradient(to bottom right, #f0f4ff, #e2f7e1)",
    minHeight: "100vh",
    paddingTop: "3rem",
    fontFamily: "'Poppins', sans-serif",
  },
  card: {
    maxWidth: "500px",
    margin: "0 auto",
    padding: "2.5rem",
    backgroundColor: "#ffffff",
    borderRadius: "15px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
    textAlign: "center",
  },
  heading: {
    fontSize: "1.8rem",
    fontWeight: "600",
    marginBottom: "0.5rem",
    color: "#2c3e50",
  },
  subtext: {
    fontSize: "0.95rem",
    color: "#555",
    marginBottom: "1.5rem",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  input: {
    padding: "0.9rem",
    fontSize: "1rem",
    borderRadius: "8px",
    border: "1px solid #ccc",
    transition: "0.3s",
    outline: "none",
    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05)",
  },
  button: {
    padding: "0.9rem",
    backgroundColor: "#4CAF50",
    color: "white",
    fontWeight: "bold",
    fontSize: "1rem",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "background 0.3s",
  },
  message: {
    marginTop: "1.5rem",
    fontWeight: "500",
    fontSize: "1rem",
    color: "#2c3e50",
  },
};

export default CreateUser;
